import { AuthGuard } from '../../shared/services';
import { DocumentsComponent } from './documents.component';
import { Route } from '@angular/router';
import { DocumentsMecenatRoutes } from '../documents/documents_mecenat_enterprise/documents-mecenat.routes';

export const DocumentsRoutes: Route[] = [
  {
    path: 'documents',
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    children: [...DocumentsMecenatRoutes]
  }
];
